<template>
    <div class="myDialog_ myForm_">
        <el-dialog  width="700px"
        :title="$t('components.modifyForm.759488-0')"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="isShowDialog"
        :before-close="close">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row>
                <el-col :span="10">
                    <el-form-item :label="$t('components.modifyForm.759488-1')"  prop="coverImg">
                        <ScreenShots :initial="form.coverImg" 
                         @changeImg="handleChangeImg" ref="shots"
                          :width="224" :height="126"  :limit="4096000"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <div class="text">
                        <div >
                            <p>{{ $t('components.modifyForm.759488-2') }}</p>
                            <p>{{ $t('components.modifyForm.759488-3') }}</p>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('components.modifyForm.759488-4')"  prop="title">
                        <el-input maxlength="20" type="text" show-word-limit v-model="form.title" :placeholder="$t('components.modifyForm.759488-5')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
            <div slot="footer" class="myDialog_footer">
                    <el-button @click="close">{{ $t('components.modifyForm.759488-6') }}</el-button>
                    <el-button :loading="isSubmit" :disabled="isSubmit" type="primary" @click="submit">{{ $t('components.modifyForm.759488-7') }}</el-button>
                </div>
        </el-dialog>
    </div> 
</template>
<script>
import ScreenShots from 'components/Screenshots/index'
import * as api_courier from 'service/api/methods/api_courier'
import i18n from '@/locale/index';

export default {
    components:{
        ScreenShots
    },
    data(){
        return{
            isShowDialog:false,
            isSubmit:false,
            form:{
                id:'',
                coverImg:undefined,
                title:'',
            },
            rules:{
                coverImg:[
                    { required: true, message: i18n.t('components.modifyForm.759488-8'), trigger: 'change' },
                ],
                title:[
                    { required: true, message: i18n.t('components.modifyForm.759488-5'), trigger: 'change' },
                ],
            },
        }
    },
    methods:{
        /* 切换弹窗开关状态 */
        init(value,rows) {
            this.isShowDialog = value;
            if(rows){
                this.form.id=rows.id;
                this.form.coverImg=rows.coverImg;
                this.form.title=rows.title;
                console.log(this.form.coverImg)
            }
        },
        close(){
            this.resetForm();
        },
        /* 重置表单 */
        resetForm() {
            this.$refs.form.resetFields();
            this.form= {
                id:'',
                coverImg:undefined,
                title:'',
            };
            this.$refs.shots.initData();//清除截图插件
            this.isShowDialog = false;
            this.isSubmit = false;
        },
        submit(){
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.isSubmit = true;
                    this.$refs.shots.taps(0, 'file', this.calls); 
                } else {
                    this.isSubmit = false;
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleChangeImg(value) {
            // this.$refs.shots.taps(0, 'actfile', this.calls); 
        },
        calls(obj) {
            if(obj){
                this.form.coverImg=obj;
            }
            this.resourceUpdate(this.form);
        },
        resourceUpdate(p){//修改、上下架、删除
            api_courier.resourceUpdate(p).then((res)=>{
                this.$msg.success(res.message, this.$t('components.modifyForm.759488-9'));
                this.resetForm();
                this.$parent.getData();
            })
        },
    }
}
</script>
<style lang="less" scoped>
@import url("~utils/css/general.less");
.text{
    height: 207px;
    display: flex;
    align-items: center;
}
</style>